export enum ListTypeDetectionColorEnum {
  WHITELIST = '#088c55',
  BLACKLIST = '#c4291d',
  ALL = '#344054',
}

export const handleFacePermission = (listColor?: string) => {
  if (listColor === ListTypeDetectionColorEnum.BLACKLIST) return 'Bloqueado'
  if (listColor === ListTypeDetectionColorEnum.WHITELIST) return 'Permitido'
  return '-'
}
